export const WORKFLOW_CODE_SEARCH_FLAG = "workflow-code-search";

// Gates the baseline CSP the public service adds to the html-viewer harness
// and to step-authored HTML responses, a second defense layer next to the
// iframe sandbox attribute.
export const PUBLIC_CONTENT_CSP_FEATURE_FLAG = "public-content-csp";

// Gates the settings toggle for the tenant-wide public/external-id route
// auth kill switch. Enforcement of an already-set kill switch is not gated.
export const PUBLIC_ROUTE_AUTH_KILL_SWITCH_FLAG =
  "public-route-auth-kill-switch";

// Gates the chat model experiment: each user is deterministically assigned a
// managed chat model as their default, and end-of-session thumbs feedback and
// mid-conversation model switches are reported to Sentry.
export const MODEL_EXPERIMENT_FLAG = "model-experiment";

// Gates the "Service account (workflow identity)" variant of the 3B connector
// in the connection-type picker, so workflow → service-account self-federation
// can be tested per tenant before general rollout. UI discoverability only: the
// proxy transform and verifier are always live, so a flagged-off tenant with a
// federation binding already configured is unaffected.
export const SELF_FEDERATION_FLAG = "self-federation";

// Gates removal of the built-in `frontend-design` skill during rollout: when
// enabled for a tenant, the skill is dropped from the agent's useSkill catalog
// (workflow builder and personal chat), and it is excluded from the "Download
// code" zip.
export const HIDE_FRONTEND_DESIGN_SKILL_FLAG = "hide-frontend-design-skill";

// Gates the multi-provider SSO settings page (list paradigm with per-route IdP
// support); off shows the original single-provider page.
export const MULTI_IDP_SETTINGS_FLAG = "multi-idp-settings";
